import { useEffect, useState } from "react";
import { Palette, Plus, Save, Trash2 } from "lucide-react";

import { api, apiError } from "@/lib/api";

const emptyStatus = {
  name: "",
  category: "informativo",
  color: "#7C5C9F",
  vendor_can_sell: false,
};

const categoryLabels = {
  disponible: "Disponible / reservable",
  reservado: "Reservado / permite concretar",
  vendido: "Vendido / contabiliza venta",
  bloqueado: "Bloqueado / sin operaciones",
  informativo: "Informativo / color especial",
};

export default function LotStatusSettingsPanel() {
  const [statuses, setStatuses] = useState([]);
  const [newStatus, setNewStatus] = useState(emptyStatus);
  const [message, setMessage] = useState("");

  const loadStatuses = () => api.get("/settings/lot-statuses").then((response) => setStatuses(response.data));

  useEffect(() => {
    loadStatuses();
  }, []);

  const createStatus = async (event) => {
    event.preventDefault();
    try {
      await api.post("/settings/lot-statuses", newStatus);
      setNewStatus(emptyStatus);
      setMessage("Estado creado correctamente.");
      loadStatuses();
    } catch (error) {
      setMessage(apiError(error));
    }
  };

  const updateStatus = async (status) => {
    try {
      await api.put(`/settings/lot-statuses/${status.id}`, {
        name: status.name,
        category: status.category,
        color: status.color,
        vendor_can_sell: status.vendor_can_sell,
      });
      setMessage("Estado actualizado.");
      loadStatuses();
    } catch (error) {
      setMessage(apiError(error));
    }
  };

  const removeStatus = async (status) => {
    if (!window.confirm(`¿Eliminar el estado ${status.name}?`)) return;
    try {
      await api.delete(`/settings/lot-statuses/${status.id}`);
      setMessage("Estado eliminado.");
      loadStatuses();
    } catch (error) {
      setMessage(apiError(error));
    }
  };

  const changeStatus = (id, changes) => {
    setStatuses((current) => current.map((status) => (
      status.id === id ? { ...status, ...changes } : status
    )));
  };

  return (
    <section className="lot-status-settings-panel" data-testid="lot-status-settings-panel">
      <div className="panel-heading">
        <div><span className="eyebrow">ESTADOS COMERCIALES</span><h2>Colores y comportamiento</h2></div>
        <Palette size={21} />
      </div>
      <p>
        Crea estados como Garantía comercial o Pedro Colanzi, define su color y decide si el vendedor puede operarlos.
      </p>
      <form className="status-create-form" data-testid="status-create-form" onSubmit={createStatus}>
        <input data-testid="status-name-input" onChange={(e) => setNewStatus({ ...newStatus, name: e.target.value })} placeholder="Nombre del estado" required value={newStatus.name} />
        <select data-testid="status-category-select" onChange={(e) => setNewStatus({ ...newStatus, category: e.target.value })} value={newStatus.category}>{Object.entries(categoryLabels).map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select>
        <input data-testid="status-color-input" onChange={(e) => setNewStatus({ ...newStatus, color: e.target.value })} type="color" value={newStatus.color} />
        <label className="status-vendor-check"><input checked={newStatus.vendor_can_sell} data-testid="status-vendor-sell-checkbox" onChange={(e) => setNewStatus({ ...newStatus, vendor_can_sell: e.target.checked })} type="checkbox" /> Vendedor puede operar</label>
        <button className="primary-button" data-testid="create-status-button" type="submit"><Plus size={16} /> Agregar estado</button>
      </form>
      {message && <p className="form-note" data-testid="status-settings-message">{message}</p>}
      <div className="status-list" data-testid="status-list">
        {statuses.map((status) => <article data-testid={`status-row-${status.id}`} key={status.id}><input aria-label={`Color de ${status.name}`} className="status-color-swatch" data-testid={`status-color-${status.id}`} onChange={(e) => changeStatus(status.id, { color: e.target.value })} type="color" value={status.color} /><input className="status-name-edit" data-testid={`status-name-${status.id}`} disabled={status.system} onChange={(e) => changeStatus(status.id, { name: e.target.value })} value={status.name} /><select data-testid={`status-category-${status.id}`} disabled={status.system} onChange={(e) => changeStatus(status.id, { category: e.target.value })} value={status.category}>{Object.entries(categoryLabels).map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select><label className="status-vendor-check"><input checked={status.vendor_can_sell} data-testid={`status-vendor-${status.id}`} onChange={(e) => changeStatus(status.id, { vendor_can_sell: e.target.checked })} type="checkbox" /> Vendedor puede operar</label><span>{status.lot_count} lotes</span><button aria-label="Guardar estado" className="icon-button" data-testid={`save-status-${status.id}`} onClick={() => updateStatus(status)} type="button"><Save size={16} /></button><button aria-label="Eliminar estado" className="icon-button danger" data-testid={`delete-status-${status.id}`} disabled={status.system || status.lot_count > 0} onClick={() => removeStatus(status)} type="button"><Trash2 size={16} /></button></article>)}
      </div>
    </section>
  );
}
